export const SmartlifeLogo = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='108'
    height='22'
    viewBox='0 0 108 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_141_4163)'>
      <path
        d='M19.3569 21.9811L19.7655 0.172852H22.7386L26.5918 17.864L30.4732 0.172852H33.4464L33.8549 21.9811H31.3941L31.1584 6.13171L27.4592 21.9811H25.7495L22.0786 6.13171L21.8429 21.9811H19.3569Z'
        fill='url(#paint0_linear_141_4163)'
      />
      <path
        d='M38.6353 21.9811V0.172852H43.0164C45.2258 0.172852 46.8475 0.625423 47.8753 1.52742C48.9061 2.42942 49.4215 3.90342 49.4215 5.94628C49.4215 8.75285 48.5227 10.45 46.725 11.0377L49.8427 21.9811H46.8947L44.0284 11.748H41.6744V21.9811H38.6353ZM41.6744 9.56371H42.8184C44.1415 9.56371 45.0875 9.30285 45.6533 8.78114C46.219 8.25942 46.5018 7.31342 46.5018 5.94628C46.5018 4.62314 46.2598 3.69285 45.7727 3.15857C45.2855 2.62428 44.3678 2.35714 43.0164 2.35714H41.6744V9.56371Z'
        fill='url(#paint1_linear_141_4163)'
      />
      <path
        d='M56.2791 21.9811V2.42314H52.2939V0.172852H63.1588V2.42314H59.3182V21.9811H56.2791Z'
        fill='url(#paint2_linear_141_4163)'
      />
      <path
        d='M68.6147 21.9811V0.172852H70.6796V20.4443H76.8867V21.9843H68.6147V21.9811Z'
        fill='#F2F2F2'
      />
      <path
        d='M80.4321 21.9811V0.172852H82.4593V21.9811H80.4321Z'
        fill='#F2F2F2'
      />
      <path
        d='M87.7393 21.9811V0.172852H95.6058V1.71285H89.8041V9.90628H94.6315V11.4337H89.8041V21.9843H87.7393V21.9811Z'
        fill='#F2F2F2'
      />
      <path
        d='M99.5591 21.9811V0.172852H107.438V1.75057H101.624V9.91885H106.385V11.4463H101.624V20.4443H107.504V21.9843H99.5591V21.9811Z'
        fill='#F2F2F2'
      />
      <path
        d='M11.5815 11.1697L11.1729 10.8963L11.176 10.8931L8.3726 9.02L8.36632 9.02314L6.8766 8.03C5.65718 7.216 5.51575 5.94314 5.79546 5.016C6.07518 4.09514 6.89546 3.11143 8.36318 3.11143C9.83089 3.11143 10.6543 4.09514 10.934 5.01914C11.0126 5.27371 11.0566 5.55343 11.0566 5.84257C11.0566 6.41143 10.8806 7.018 10.428 7.53343L13.0146 9.284C14.1177 7.84457 14.476 5.97143 13.9135 4.11714C13.156 1.61543 10.978 0 8.36632 0C5.75461 0 3.5766 1.61543 2.81918 4.11714C2.1466 6.336 2.79403 8.59257 4.46603 10.0886L8.74032 13.0146L9.85289 13.7563C11.0755 14.5703 11.2137 15.84 10.934 16.7671C10.6543 17.688 9.83403 18.6749 8.36318 18.6749C6.89546 18.6749 6.07203 17.6911 5.79546 16.7671C5.56603 16.016 5.61946 15.0229 6.31403 14.2403L3.74003 12.4709C2.97003 13.464 2.55518 14.6646 2.55518 15.928C2.55518 16.5 2.64003 17.0877 2.81603 17.6691C3.57346 20.1709 5.75146 21.7863 8.36318 21.7863C10.978 21.7863 13.1529 20.1709 13.9135 17.6691C14.6709 15.1737 13.7563 12.6186 11.5815 11.1697Z'
        fill='url(#paint3_linear_141_4163)'
      />
      <mask
        id='mask0_141_4163'
        mask-type='luminance'
        maskUnits='userSpaceOnUse'
        x='-1'
        y='-4'
        width='20'
        height='19'
      >
        <path
          d='M10.2431 -3.77029L-0.000976562 5.02002L7.87039 14.1932L18.1145 5.4029L10.2431 -3.77029Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_141_4163)'>
        <path
          d='M11.581 11.2073L11.1724 10.9339L11.1755 10.9307L8.37212 9.0576L8.36583 9.06074L6.87612 8.0676C5.65669 7.2536 5.51526 5.98074 5.79497 5.0536C6.07469 4.13274 6.89497 3.14903 8.36269 3.14903C9.8304 3.14903 10.6538 4.13274 10.9335 5.05674C11.0121 5.31131 11.0561 5.59103 11.0561 5.88017C11.0561 6.44903 10.8801 7.0556 10.4275 7.57103L13.0141 9.3216C14.1173 7.88217 14.4755 6.00903 13.913 4.15474C13.1555 1.65303 10.9775 0.0375977 8.36583 0.0375977C5.75412 0.0375977 3.57612 1.65303 2.81869 4.15474C2.14612 6.3736 2.79354 8.63017 4.46554 10.1262L8.73983 13.0522L9.8524 13.7939C11.075 14.6079 11.2133 15.8776 10.9335 16.8047C10.6538 17.7256 9.83355 18.7125 8.36269 18.7125C6.89497 18.7125 6.07155 17.7287 5.79497 16.8047C5.56555 16.0536 5.61897 15.0605 6.31355 14.2779L3.73954 12.5085C2.96954 13.5016 2.55469 14.7022 2.55469 15.9656C2.55469 16.5376 2.63954 17.1253 2.81554 17.7067C3.57297 20.2085 5.75097 21.8239 8.36269 21.8239C10.9775 21.8239 13.1524 20.2085 13.913 17.7067C14.6704 15.2113 13.7558 12.6562 11.581 11.2073Z'
          fill='url(#paint4_linear_141_4163)'
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_141_4163'
        x1='26.6046'
        y1='0.17282'
        x2='26.6046'
        y2='21.9817'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#65C8D0' />
        <stop offset='1' stopColor='#3A8CA5' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_141_4163'
        x1='44.2378'
        y1='0.17282'
        x2='44.2378'
        y2='21.9817'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#65C8D0' />
        <stop offset='1' stopColor='#3A8CA5' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_141_4163'
        x1='57.7273'
        y1='0.17282'
        x2='57.7273'
        y2='21.9817'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#65C8D0' />
        <stop offset='1' stopColor='#3A8CA5' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_141_4163'
        x1='2.55618'
        y1='10.8972'
        x2='14.1774'
        y2='10.8972'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#65C8D0' />
        <stop offset='1' stopColor='#3A8CA5' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_141_4163'
        x1='2.55569'
        y1='10.9348'
        x2='14.1769'
        y2='10.9348'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F7931E' />
        <stop offset='1' stopColor='#DB9F5D' stopOpacity='0.9' />
      </linearGradient>
      <clipPath id='clip0_141_4163'>
        <rect width='107.486' height='22' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
